import React from 'react'
import { ArrowSquareOut, BookOpen, Globe, Question } from '@phosphor-icons/react'
import { Icon } from '@shopflo/ui'
import { show } from '@intercom/messenger-js-sdk'

import type { DocumentationLink } from 'src/lib/types/appsIntegrations'

export type { DocumentationLink }

interface DocumentationLinksProps {
  documentations?: DocumentationLink[]
  helpUrl?: string
}

const linkClass =
  'flex items-center gap-2 py-1.5 text-text-xs-medium text-zinc-500 hover:text-zinc-700 transition-colors text-left'

const linkIcon = (name: string | undefined) => {
  const n = (name ?? '').toLowerCase()
  if (n.includes('doc')) return <Icon IconComponent={BookOpen} size='sm' className='flex-shrink-0' />
  if (n.includes('website')) return <Icon IconComponent={Globe} size='sm' className='flex-shrink-0' />
  if (n.includes('help') || n.includes('?'))
    return <Icon IconComponent={Question} size='sm' className='flex-shrink-0' />
  return <Icon IconComponent={ArrowSquareOut} size='sm' className='flex-shrink-0' />
}

const DocumentationLinks: React.FC<DocumentationLinksProps> = ({ documentations, helpUrl }) => {
  const valid = documentations?.filter(d => d.url && d.name) ?? []
  const trimmedHelp = helpUrl?.trim()
  const hasHelp = Boolean(trimmedHelp)
  if (!valid.length && !hasHelp) return null

  return (
    <div className='flex flex-col'>
      {valid.map((doc, i) => (
        <a key={i} href={doc.url!} target='_blank' rel='noopener noreferrer' className={linkClass}>
          {linkIcon(doc.name)}
          {doc.name}
        </a>
      ))}
      {hasHelp &&
        (trimmedHelp === 'INTERCOM' ? (
          <button type='button' onClick={() => show()} className={linkClass}>
            {linkIcon('help')}
            Help Needed?
          </button>
        ) : (
          <a href={trimmedHelp!} target='_blank' rel='noopener noreferrer' className={linkClass}>
            {linkIcon('help')}
            Help Needed?
          </a>
        ))}
    </div>
  )
}

export default DocumentationLinks
